import apiClient from "../lib/apiClient";
import type { MemberRole, MemberStatus } from "./types";

export interface UserDto {
  title?: string;
  username?: string;
  name?: string;
  email?: string;
  password?: string | null;
  phone?: string;
  mobilePhone?: string;
}

export interface InviteDto {
  title?: string;
  username?: string;
  name?: string;
  email?: string;
  url?: string;
}

export interface RegisterDto {
  user: UserDto;
}

export interface InviteMemberDto {
  user: InviteDto;
  role: MemberRole;
  assignedParcoursIds?: string[];
}

export interface MemberDto {
  role: MemberRole;
  assignedParcoursIds?: string[];
}

export interface MemberResponse {
  id: string;
  userId: string;
  userName?: string;
  tenantId: string;
  role: MemberRole;
  status: MemberStatus;
  assignedParcoursIds: string[];
  addedAt: string;
  updatedAt: string;
}

export interface RegisterResponse {
  user: { userID: string; name?: string; email?: string };
  role: MemberRole;
  status: MemberStatus;
  message: string;
  addedAt: string;
}

export async function getMyMember() {
  const { data } = await apiClient.get<MemberResponse>("/member/me");
  return data;
}

export async function listMembers() {
  const { data } = await apiClient.get<MemberResponse[]>("/member");
  return data;
}

export async function getMember(id: string) {
  const { data } = await apiClient.get<MemberResponse>(`/member/${id}`);
  return data;
}

export async function registerMember(dto: RegisterDto) {
  const { data } = await apiClient.post<RegisterResponse>("/member/register", dto);
  return data;
}

export async function inviteMember(dto: InviteMemberDto) {
  const { data } = await apiClient.post<RegisterResponse>("/member/invite", dto);
  return data;
}

export async function updateMember(id: string, dto: MemberDto) {
  const { data } = await apiClient.put<MemberResponse>(`/member/${id}`, dto);
  return data;
}

export async function updateMemberStatus(id: string, status: MemberStatus) {
  const { data } = await apiClient.put<MemberResponse>(`/member/${id}/status`, null, { params: { status } });
  return data;
}

export async function deleteMember(id: string) {
  await apiClient.delete(`/member/${id}`);
}

export async function assignParcours(memberId: string, parcoursId: string) {
  const { data } = await apiClient.post<MemberResponse>(`/member/${memberId}/parcours/${parcoursId}`);
  return data;
}

export async function unassignParcours(memberId: string, parcoursId: string) {
  const { data } = await apiClient.delete<MemberResponse>(`/member/${memberId}/parcours/${parcoursId}`);
  return data;
}
